import { Dropdown } from "primereact/dropdown";
import React from "react";
import useWindowDimensions from "../hooks/useDimensions";

const dropdownOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 }
];

export const TablePaginator = (dropOptions = dropdownOptions) => {
    const { width, height } = useWindowDimensions()

    const tablePaginator = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
    
            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none', fontSize: width <= 768 && '14px' }}>Elementos por página:</span>
                    <Dropdown className='sel' value={options.value} options={dropOptions} onChange={options.onChange} style={{width: width <= 768 && '5.2rem', fontSize: width <= 768 && '14px'}}/>
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center', fontSize: width <= 768 && '14px' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    }

    return tablePaginator
};